
import { Tenant } from '../types';

export type BusinessType = Tenant['businessType'];

export interface TenantCapabilities {
  allowedComponents: string[]; // IDs dos widgets permitidos (ex: 'hero', 'rooms', 'fishing-reports')
  defaultPages: string[];      // Slugs das páginas padrão
  features: {
    bookings: boolean;         // Motor de reservas
    fishingReports: boolean;   // Relatórios de pesca
    events: boolean;           // Eventos e competições
    fleet: boolean;            // Frota/Barcos
    shop: boolean;             // E-commerce/Loja
  };
}

const COMMON_COMPONENTS = [
  'header', 'footer', 'hero', 'about', 'contact', 'gallery', 'faq', 'testimonials'
];

export const CAPABILITIES_BY_TYPE: Record<BusinessType, TenantCapabilities> = {
  lodge: {
    allowedComponents: [...COMMON_COMPONENTS, 'rooms', 'packages', 'fishing-reports', 'location', 'guides'],
    defaultPages: ['home', 'acomodacoes', 'pacotes', 'relatos', 'contato'],
    features: { bookings: true, fishingReports: true, events: false, fleet: true, shop: true }
  },
  hotel: {
    allowedComponents: [...COMMON_COMPONENTS, 'rooms', 'amenities', 'location', 'restaurant'],
    defaultPages: ['home', 'acomodacoes', 'lazer', 'reservas', 'contato'],
    features: { bookings: true, fishingReports: false, events: true, fleet: false, shop: false }
  },
  fishing_guide: {
    allowedComponents: [...COMMON_COMPONENTS, 'bio', 'fishing-reports', 'services', 'calendar'],
    defaultPages: ['home', 'sobre', 'servicos', 'agenda', 'contato'],
    features: { bookings: true, fishingReports: true, events: false, fleet: true, shop: false }
  },
  tour_operator: {
    allowedComponents: [...COMMON_COMPONENTS, 'destinations', 'packages', 'reviews'],
    defaultPages: ['home', 'destinos', 'pacotes', 'sobre', 'contato'],
    features: { bookings: true, fishingReports: true, events: false, fleet: false, shop: false }
  },
  association: {
    allowedComponents: [...COMMON_COMPONENTS, 'members', 'directory', 'events', 'news', 'governance'],
    defaultPages: ['home', 'associados', 'eventos', 'noticias', 'estatuto', 'contato'],
    features: { bookings: false, fishingReports: true, events: true, fleet: false, shop: true }
  },
  fishing_pond: { // Pesqueiro
    allowedComponents: [...COMMON_COMPONENTS, 'lakes', 'rules', 'prices', 'restaurant', 'events'],
    defaultPages: ['home', 'lagos', 'regras', 'precos', 'torneios', 'contato'],
    features: { bookings: false, fishingReports: true, events: true, fleet: false, shop: true }
  },
  turma: { // Turma de Pesca
    allowedComponents: [...COMMON_COMPONENTS, 'members', 'gallery', 'events', 'blog'],
    defaultPages: ['home', 'membros', 'galeria', 'eventos', 'contato'],
    features: { bookings: false, fishingReports: true, events: true, fleet: false, shop: false }
  },
};

export const getTenantCapabilities = (type: BusinessType): TenantCapabilities => {
  return CAPABILITIES_BY_TYPE[type] || CAPABILITIES_BY_TYPE['lodge'];
};
